document.addEventListener('DOMContentLoaded', () => {
  const image = document.querySelector('.hero-image');
  const wrapper = document.querySelector('.hero-image-wrapper');
  const mediaQuery = window.matchMedia('(min-width: 750px)');

  if (!image || !wrapper) return;

  function rotateAndScale() {
    const width = window.innerWidth;
    const maxDeg = 45;
    const extraWidth = Math.max(0, width - 750);
    const deg = Math.min(maxDeg, extraWidth * 0.05);
    const radians = deg * (Math.PI / 180);
  
    const iw = image.offsetWidth;
    const ih = iw * (5 / 4); // your image ratio 16 / 10
  
    // Calculate rotated bounding box
    const rotatedWidth = Math.abs(iw * Math.cos(radians)) + Math.abs(ih * Math.sin(radians));
    const rotatedHeight = Math.abs(iw * Math.sin(radians)) + Math.abs(ih * Math.cos(radians));
  
    // Calculate scale to fit inside viewport width
    const scale = Math.min(1, width / rotatedWidth);
  
    // Set wrapper height to rotated height * scale
    wrapper.style.height = `${rotatedHeight * scale}px`;
  
    // Apply transform: scale first, then rotate and translate center
    image.style.transform = `translate(-50%, -50%) rotate(${deg}deg) scale(${scale})`;
  }

  function handleResize() {
    requestAnimationFrame(rotateAndScale);
  }

  function handleTabletChange(e) {
    if (e.matches) {
      rotateAndScale();
      window.addEventListener('resize', handleResize);
    } else {
      // Reset everything cleanly on mobile
      image.style.transform = '';
      wrapper.style.height = '';
      wrapper.style.transform = '';
      image.style.left = '';
      image.style.top = '';
    }
  }

  mediaQuery.addEventListener('change', handleTabletChange);
  handleTabletChange(mediaQuery);
});
